module.exports = __webpack_public_path__ + "img/icon_trust.75060d19.png";